module.exports = __webpack_public_path__ + "img/16.fddfbce3.jpg";